import "./Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import LinkButton from "components/LinkButton";
import ProfileModal from "components/ProfileModal";
import { useAppSelector } from "store/hooks";

import LogoLink from "./LogoLink";

type HeaderProps = {
  logoType?: "simple" | "standard";
  logoLink: string;
  children?: ReactNode;
  displayProfile?: boolean;
  adminLink?: ReactNode;
  helper?: ReactNode;
};

const Header = ({
  logoType = "standard",
  logoLink,
  displayProfile,
  adminLink,
  helper,
  children,
}: HeaderProps) => {
  const hasErrorButton = useAppSelector((state) =>
    selectFeatureFlag(state, "hasErrorButton")
  );

  return (
    <header className="Header">
      <LogoLink url={logoLink} type={logoType} />
      <div className="section__container--center">{children}</div>
      <div className="section__container--end">
        {displayProfile && <ProfileModal />}
        {adminLink}
        {hasErrorButton && (
          <LinkButton
            onClick={() => {
              throw new Error("Error button clicked");
            }}
          >
            <FontAwesomeIcon
              icon="triangle-exclamation"
              color="darkred"
              opacity={0.6}
            />
          </LinkButton>
        )}
        {helper}
      </div>
    </header>
  );
};

export default Header;
